import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, catchError } from "rxjs";
import { environment } from "../../environments/environment";
import { ApiResponse, PaginatedData } from "../domain/models/apiResponse";
import IManageCards from "../domain/ports/manage/i-manage-cards";
import { Card, CreateCardRequestDto, UpdateCardRequestDto } from "../domain/models/card";

@Injectable({ providedIn: 'root' })
export class CardAdapterService implements IManageCards {
  private baseUrl = environment.urlApi;

  constructor(private http: HttpClient) {}

  getCards(pageIndex: number, pageSize: number): Observable<ApiResponse<PaginatedData<Card>>> {
    return this.http.get<ApiResponse<PaginatedData<Card>>>(`${this.baseUrl}api/v1/Card`, {
      params: {
        pageIndex: pageIndex.toString(),
        pageSize: pageSize.toString()
      }
    }).pipe(
      catchError(err => {
        console.error("Error in getCards", err);
        throw err;
      })
    );
  }

  getCardByModuleId(id: number): Observable<ApiResponse<Card[]>> {
    return this.http.get<ApiResponse<Card[]>>(`${this.baseUrl}api/v1/Card/module/${id}`).pipe(
      catchError(err => {
        console.error("Error in getCardById", err);
        throw err;
      })
    );
  }
   existsNameCard(name: string): Observable<ApiResponse<boolean>> {
    return this.http.get<ApiResponse<boolean>>(`${this.baseUrl}api/v1/Card/${name}`).pipe(
      catchError(err => {
        console.error("Error in existsNameCard", err);
        throw err;
      })
    );
  }
}

